import { useEffect, useState } from "react";

// Below Tailwind's `md` (768px) list screens swap their table for cards. A
// media query in JS (not CSS `md:hidden`) so only one of the two is rendered —
// rendering both would double every row's buttons for screen readers.
export const PHONE_QUERY = "(max-width: 767px)";

const matchesPhone = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia(PHONE_QUERY).matches
    : false;

function useIsPhone() {
  const [isPhone, setIsPhone] = useState(matchesPhone);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setIsPhone(query.matches);
    onChange();
    // Safari < 14 only has the deprecated addListener.
    if (query.addEventListener) {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return isPhone;
}

export default useIsPhone;
